// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6d228a23","488":"a66674e2","977":"2f45887b"}[chunkId] + ".chunk.js";
};